<template>
    <ValidationProvider
        :vid="vid"
        :rules="rules"
        :name="label"
        v-slot="{ errors }"
        tag="div"
        class="form-group"
        :class="{ 'form-group-compact': compact, 'mb-0': noBottomMargin }"
    >
        <label v-if="label && !hideLabel">{{ label }}<span v-if="required" class="text-danger">*</span></label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span
                    class="input-group-text"
                    style="padding: 3px 8px;"
                >
                    <input
                        class="cp__input"
                        type="color"
                        :value="value"
                        @input="handleEvent"
                        :disabled="disabled"
                    />
                </span>
            </div>
            <b-form-input
                :placeholder="placeholder ? placeholder : label"
                type="text"
                :value="value"
                @input="handleInput"
                :disabled="disabled"
                :state="(errors.length > 0 ? false : null)"
            />
        </div>
        <span class="validation-invalid-label">{{ getInvalidFeedback(errors) }}</span>
    </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';

export default {
    name: 'ColorPicker',
    props: {
        vid: null,
        rules: {
            type: [String, Object, Array],
            default: '',
        },
        value: null,
        label: String,
        hideLabel: {
            type: Boolean,
            default: false,
        },
        placeholder: String,
        disabled: {
            type: Boolean,
            default: false,
        },
        compact: {
            type: Boolean,
            default: false,
        },
        noBottomMargin: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ValidationProvider,
    },
    methods: {
        handleEvent(event) {
            this.handleInput(event.target.value);
        },
        handleInput(value) {
            if (value && value.length === 7) {
                this.$emit('input', value);
            }
        },
        getInvalidFeedback(errors, key = null) {
            if (key) {
                if (Array.isArray(errors[key]) && errors[key].length) {
                    return errors[key].join(', ');
                }
            }

            if (Array.isArray(errors) && errors.length) {
                return errors.join(', ');
            }

            return null;
        },
    },
    computed: {
        required() {
            if (this.rules instanceof Object) {
                return this.rules.required ?? false;
            }
            return this.rules?.includes('required') ?? false;
        },
    },
};
</script>
<style lang="css" scoped>
.cp__input {
    height: 24px;
    width: 24px;
    border-radius: 0px;
    border: none;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    padding: 0;
}
.cp__input::-webkit-color-swatch-wrapper {
    padding: 0;
}
.cp__input::-webkit-color-swatch {
    border: none;
    border-radius: 15px;
}
.cp__input::-moz-color-swatch {
    border: none;
    border-radius: 15px;
}
</style>
